import { Component, type ReactNode } from 'react'

interface Props { children: ReactNode }
interface State { error: Error | null; stack: string | null }

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null, stack: null }
  static getDerivedStateFromError(error: Error) {
    return { error, stack: error.stack || null }
  }
  render() {
    if (this.state.error) {
      const language = localStorage.getItem('biograph-language') === 'en' ? 'en' : 'ru'
      const text = language === 'ru'
        ? {
            title: 'Произошла ошибка',
            body: 'Перезагрузите страницу. Если ошибка повторится, вернитесь к подбору и попробуйте снова.',
            reload: 'Перезагрузить страницу',
            details: 'Технические подробности',
          }
        : {
            title: 'Something went wrong',
            body: 'Reload the page. If the problem continues, return to the stack builder and try again.',
            reload: 'Reload page',
            details: 'Technical details',
          }
      return (
        <div style={{ color: '#f0ede6', background: '#090a09', padding: 'clamp(28px, 6vw, 72px)', fontFamily: 'Arial, sans-serif', minHeight: '100vh' }}>
          <div style={{ maxWidth: '720px', margin: '12vh auto 0', borderTop: '1px solid #3a3d38', paddingTop: '28px' }}>
            <h1 style={{ fontSize: 'clamp(30px, 5vw, 56px)', fontWeight: 500, margin: '0 0 18px' }}>{text.title}</h1>
            <p style={{ color: '#aaa9a3', fontSize: '17px', lineHeight: 1.6, maxWidth: '620px' }}>{text.body}</p>
            <button type="button" onClick={() => window.location.reload()} style={{ marginTop: '22px', padding: '14px 20px', border: '1px solid #f0ede6', background: '#f0ede6', color: '#090a09', cursor: 'pointer', fontWeight: 600 }}>{text.reload}</button>
            <details style={{ marginTop: '28px', color: '#777a74' }}>
              <summary style={{ cursor: 'pointer' }}>{text.details}</summary>
              <pre style={{ whiteSpace: 'pre-wrap', fontSize: '12px', lineHeight: 1.6 }}>{this.state.error.message}{'\n'}{this.state.stack}</pre>
            </details>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
